import React, { Dispatch, SetStateAction } from 'react';
import { UpdateRejectedProcurementType } from 'models/procurement.model';
import UpdateProcurementForm from './update-rejected-procurement-form';

const UpdateRejectedProcurementDetails = ({
  formData,
  setValue,
  removeItem,
  addForm,
  canWrite,
  vendorIngredientIdsToDelete,
  setVendorIngredientIdsToDelete
}: {
  formData: UpdateRejectedProcurementType[];
  setValue: (index: number, field: keyof UpdateRejectedProcurementType, value: string) => void;
  removeItem: (index: number) => void;
  addForm: () => void;
  canWrite: boolean;
  vendorIngredientIdsToDelete: string[];
  setVendorIngredientIdsToDelete: Dispatch<SetStateAction<string[]>>;
}) => {
  return (
    <div>
      {formData
        .filter((vendor_ingredient) => !vendorIngredientIdsToDelete.includes(vendor_ingredient.id))
        .map((data, index) => (
          <UpdateProcurementForm
            key={index}
            data={data}
            index={index}
            setValue={setValue}
            removeItem={removeItem}
            canWrite={canWrite}
            setVendorIngredientIdsToDelete={setVendorIngredientIdsToDelete}
          />
        ))}
      {canWrite && (
        <button onClick={addForm} className='text-[#0080E5] mt-2 font-medium text-sm'>
          + Add Item
        </button>
      )}
    </div>
  );
};

export default UpdateRejectedProcurementDetails;
